/* npd-pdp.js — behaviour for the product page sections.
   Everything is delegated off document, so sections added in the theme editor
   work without a re-init. All state classes match what npd-pdp.css styles. */
(function () {
  'use strict';

  /* Every section renders its own <script> tag, so this file can be executed
     many times on one page. Without this guard each delegated listener is
     registered once per section: a state flip would flip once per copy (even
     counts cancelling out), and one add-to-cart click would post one request
     per copy. Register everything exactly once. */
  if (window.__npdPdpInit) return;
  window.__npdPdpInit = true;

  /* ------------------------------------------------------------------ utils */

  var money = function (cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, format); } catch (e) {}
    }
    var v = (cents / 100);
    var s = v % 1 === 0 ? v.toFixed(0) : v.toFixed(2);
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  var $  = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  var on = function (type, selector, handler) {
    document.addEventListener(type, function (e) {
      var el = e.target.closest ? e.target.closest(selector) : null;
      if (el) handler(e, el);
    }, type === 'scroll' ? true : false);
  };

  /* ------------------------------------------------------- product gallery */

  function galleryFor(el) { return el.closest('.custom-gallery'); }

  function syncThumbs(gallery) {
    var slides = $$('.custom-gallery__slide', gallery);
    var track  = $('.custom-gallery__slides', gallery);
    if (!track || !slides.length) return;
    var mid = track.scrollLeft + track.clientWidth / 2;
    var index = 0, best = Infinity;
    slides.forEach(function (s, i) {
      var c = s.offsetLeft + s.offsetWidth / 2;
      var d = Math.abs(c - mid);
      if (d < best) { best = d; index = i; }
    });
    setIndex(gallery, index);
  }

  function setIndex(gallery, index) {
    var slides = $$('.custom-gallery__slide', gallery);
    index = Math.max(0, Math.min(slides.length - 1, index));
    gallery.dataset.index = index;
    slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
    $$('.custom-gallery__thumb-item', gallery).forEach(function (t, i) {
      var btn = t.querySelector('.custom-gallery__thumb-btn') || t;
      t.classList.toggle('is-active', i === index);
      btn.classList.toggle('is-active', i === index);
      btn.setAttribute('aria-current', i === index ? 'true' : 'false');
    });
    /* keep the active thumbnail in view */
    var thumbs = $('.custom-gallery__thumbnails', gallery);
    var active = $$('.custom-gallery__thumb-item', gallery)[index];
    if (thumbs && active && thumbs.scrollWidth > thumbs.clientWidth) {
      var want = active.offsetLeft - (thumbs.clientWidth - active.offsetWidth) / 2;
      thumbs.scrollTo({ left: Math.max(0, want), behavior: 'smooth' });
    }
    return index;
  }

  function goToSlide(gallery, index) {
    var track = $('.custom-gallery__slides', gallery);
    var slides = $$('.custom-gallery__slide', gallery);
    if (!track || !slides.length) return;
    index = setIndex(gallery, index);
    var left = slides[index].offsetLeft - slides[0].offsetLeft;
    /* Assign scrollLeft rather than scrollTo({behavior:'smooth'}): the track already
       carries `scroll-behavior: smooth` in CSS, so this animates the same way but
       always finishes exactly on the slide. A scripted smooth scroll can be cut
       short by scroll-snap and leave the track a few pixels off. */
    track.scrollLeft = left;
  }

  on('click', '.custom-gallery__thumb-btn', function (e, btn) {
    e.preventDefault();
    var gallery = galleryFor(btn);
    if (!gallery) return;
    goToSlide(gallery, $$('.custom-gallery__thumb-item', gallery).indexOf(btn.closest('.custom-gallery__thumb-item')));
  });

  on('click', '.custom-gallery__arrow', function (e, btn) {
    e.preventDefault();
    var gallery = galleryFor(btn);
    if (!gallery) return;
    var count = $$('.custom-gallery__slide', gallery).length;
    var cur = parseInt(gallery.dataset.index || '0', 10);
    var next = btn.classList.contains('custom-gallery__arrow--prev') ? cur - 1 : cur + 1;
    goToSlide(gallery, Math.max(0, Math.min(count - 1, next)));
  });

  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (track && track.classList && track.classList.contains('custom-gallery__slides')) {
      var gallery = galleryFor(track);
      if (!gallery) return;
      clearTimeout(gallery._t);
      gallery._t = setTimeout(function () { syncThumbs(gallery); }, 60);
    }
  }, true);

  /* The gallery track is overflow:hidden (that is how the reference theme has it),
     so a phone cannot flick it. Drive it from pointer events instead. */

  function attachGalleryDrag(gallery) {
    var track = $('.custom-gallery__slides', gallery);
    if (!track || track._npdDrag) return;
    track._npdDrag = true;

    var startX = 0, startScroll = 0, dragging = false, moved = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true; moved = 0;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.style.scrollBehavior = 'auto';
    });

    track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 6) {
        moved = dx;
        track.scrollLeft = startScroll - dx;
        e.preventDefault();
      }
    }, { passive: false });

    var end = function () {
      if (!dragging) return;
      dragging = false;
      track.style.scrollBehavior = '';
      var slides = $$('.custom-gallery__slide', gallery);
      var cur = parseInt(gallery.dataset.index || '0', 10);
      var next = Math.abs(moved) > 40 ? (moved < 0 ? cur + 1 : cur - 1) : cur;
      goToSlide(gallery, Math.max(0, Math.min(slides.length - 1, next)));
      setTimeout(function () { syncThumbs(gallery); }, 260);
    };
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('pointerleave', end);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* keyboard: left / right move between slides when the track has focus */
    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      var slides = $$('.custom-gallery__slide', gallery);
      var cur = parseInt(gallery.dataset.index || '0', 10);
      goToSlide(gallery, Math.max(0, Math.min(slides.length - 1, cur + (e.key === 'ArrowRight' ? 1 : -1))));
    });
  }

  /* -------------------------------------------------- ingredients modal */

  on('click', '[data-npd-ingredients-open]', function (e, btn) {
    e.preventDefault();
    var scope = btn.closest('.npd') || document;
    var dlg = $('.product-ingredients-modal', scope);
    if (!dlg) return;
    if (typeof dlg.showModal === 'function' && !dlg.open) dlg.showModal();
    else dlg.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
  });

  on('click', '[data-npd-ingredients-close]', function (e, btn) {
    e.preventDefault();
    var dlg = btn.closest('.product-ingredients-modal');
    if (!dlg) return;
    if (typeof dlg.close === 'function' && dlg.open) dlg.close();
    else dlg.removeAttribute('open');
    document.documentElement.style.overflow = '';
  });

  document.addEventListener('close', function (e) {
    if (e.target.classList && e.target.classList.contains('product-ingredients-modal')) {
      document.documentElement.style.overflow = '';
    }
  }, true);

  /* click the backdrop to dismiss */
  on('click', '.product-ingredients-modal', function (e, dlg) {
    if (e.target !== dlg) return;
    if (typeof dlg.close === 'function' && dlg.open) dlg.close();
    else dlg.removeAttribute('open');
    document.documentElement.style.overflow = '';
  });

  /* --------------------------------------------------------- buy box state */

  /* One source of truth per buy box: the selected variant and the selected plan. */

  function boxOf(el) { return el.closest('[data-npd-buybox]'); }

  function readVariant(box) {
    var opt = $('.nbb__variant-option.is-selected', box) || $('.nbb__variant-option', box);
    if (!opt) return null;
    return {
      id:      opt.dataset.variantId,
      price:   parseInt(opt.dataset.price || '0', 10),
      compare: parseInt(opt.dataset.compare || '0', 10),
      sub:     parseInt(opt.dataset.subPrice || opt.dataset.price || '0', 10),
      plan:    opt.dataset.sellingPlan || '',
      label:   opt.dataset.label || ''
    };
  }

  function renderBox(box) {
    var v = readVariant(box);
    if (!v) return;
    var isSub  = box.dataset.plan !== 'onetime';
    var fmt    = box.dataset.moneyFormat || '';
    var price  = isSub ? v.sub : v.price;
    var compare = v.compare || v.price;
    var saving = Math.max(0, compare - price);
    var pct    = compare ? Math.round(saving / compare * 100) : 0;

    /* hidden inputs the product form posts */
    var idInput = $('input[name="id"]', box.closest('.npd')) || $('.product-variant-id', box.closest('.npd'));
    if (idInput) idInput.value = v.id;
    $$('[data-npd-selling-plan]', box.closest('.npd')).forEach(function (input) {
      input.value = isSub ? (v.plan || '') : '';
      input.disabled = !isSub || !v.plan;
    });

    /* root state classes */
    box.classList.toggle('is-subscription-selected', isSub);
    $$('.selling-plans-alt', box).forEach(function (e) { e.classList.toggle('is-subscription-selected', isSub); });
    $$('.nstbb', box).forEach(function (e) {
      e.classList.toggle('is-sub', isSub);
      e.classList.toggle('is-ot', !isSub);
    });
    $$('.spa-toggle__switch', box).forEach(function (b) { b.setAttribute('aria-checked', isSub); });
    $$('.nstbb__toggle-btn--sub', box).forEach(function (b) { b.setAttribute('aria-pressed', isSub); });
    $$('.nstbb__toggle-btn--ot',  box).forEach(function (b) { b.setAttribute('aria-pressed', !isSub); });
    $$('.nbb__plan', box).forEach(function (p) {
      p.classList.toggle('is-selected', (p.dataset.plan === 'subscription') === isSub);
      var radio = p.querySelector('input[type="radio"]');
      if (radio) radio.checked = (p.dataset.plan === 'subscription') === isSub;
    });
    $$('.selling-plans-alt__option', box).forEach(function (o) {
      var sel = o.classList.contains('selling-plans-alt__option--subscription') === isSub;
      o.classList.toggle('is-selected', sel);
      var radio = o.querySelector('input');
      if (radio) radio.checked = sel;
    });

    /* prices */
    $$('[data-npd-price]', box).forEach(function (e) { e.textContent = money(price, fmt); });
    $$('[data-npd-price-each]', box).forEach(function (e) { e.textContent = money(price, fmt) + ' each'; });
    $$('[data-npd-compare]', box).forEach(function (e) { e.textContent = money(compare, fmt); });
    $$('[data-npd-saving]', box).forEach(function (e) { e.textContent = money(saving, fmt); });
    $$('[data-npd-congrats]', box).forEach(function (e) { e.hidden = saving <= 0; });

    /* Anything outside [data-npd-buybox] has to be found from the section root.
       The gallery's discount badge sits above the buy box in the markup, so
       scoping it to `box` never matched it and it kept Liquid's literal "0%". */
    var scope = box.closest('.npd') || document;
    $$('[data-npd-saving-pct]', scope).forEach(function (e) { e.textContent = pct + '%'; });
    $$('[data-npd-save-badge]', scope).forEach(function (e) { e.textContent = 'SAVE ' + pct + '%'; });
    $$('.product__media-discount-badge', scope).forEach(function (e) {
      e.classList.toggle('product__media-discount-badge--hidden', saving <= 0);
    });
    $$('[data-npd-atc-price]', scope).forEach(function (e) { e.textContent = money(price, fmt); });
    $$('[data-npd-atc-compare]', scope).forEach(function (e) { e.textContent = money(compare, fmt); });
    document.querySelectorAll('[data-npd-sticky-price]').forEach(function (e) { e.textContent = money(price, fmt); });
    document.querySelectorAll('[data-npd-sticky-compare]').forEach(function (e) { e.textContent = money(compare, fmt); });
    document.querySelectorAll('[data-npd-sticky-variant]').forEach(function (e) { e.value = v.id; });
    document.querySelectorAll('[data-npd-sticky-plan]').forEach(function (e) {
      e.value = isSub ? (v.plan || '') : '';
      e.disabled = !isSub || !v.plan;
    });

    box.dispatchEvent(new CustomEvent('npd:change', { bubbles: true, detail: { variant: v, subscription: isSub } }));
  }

  on('click', '.nbb__variant-option', function (e, opt) {
    var box = boxOf(opt); if (!box) return;
    $$('.nbb__variant-option', box).forEach(function (o) { o.classList.remove('is-selected'); });
    opt.classList.add('is-selected');
    renderBox(box);
  });

  on('click', '.nbb__plan, .nstbb__toggle-btn, .selling-plans-alt__option, .spa-toggle__head, .spa-toggle__switch, [data-npd-plan]', function (e, el) {
    var box = boxOf(el); if (!box) return;
    var wants;
    if (el.hasAttribute('data-npd-plan'))                         wants = el.getAttribute('data-npd-plan');
    else if (el.classList.contains('spa-toggle__switch') ||
             el.classList.contains('spa-toggle__head'))               wants = box.dataset.plan === 'onetime' ? 'subscription' : 'onetime';
    else if (el.dataset.plan)                                      wants = el.dataset.plan;
    else if (el.classList.contains('nstbb__toggle-btn--sub'))      wants = 'subscription';
    else if (el.classList.contains('nstbb__toggle-btn--ot'))       wants = 'onetime';
    else if (el.classList.contains('selling-plans-alt__option--subscription')) wants = 'subscription';
    else if (el.classList.contains('selling-plans-alt__option--onetime'))      wants = 'onetime';
    else return;
    box.dataset.plan = wants === 'subscription' ? 'subscription' : 'onetime';
    renderBox(box);
  });

  /* ------------------------------------------------------------- accordions */

  function animateDetails(details, open) {
    var reveal = details.querySelector('.pfaq__reveal, .npd-reveal');
    if (!reveal || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      details.open = open; return;
    }
    var start = reveal.offsetHeight;
    if (open) details.open = true;
    var end = open ? reveal.scrollHeight : 0;
    reveal.classList.add('pfaq__reveal--animating');
    reveal.style.height = (open ? 0 : start) + 'px';
    reveal.style.transition = 'height .3s cubic-bezier(.32,.72,0,1)';
    requestAnimationFrame(function () {
      reveal.style.height = end + 'px';
    });
    var done = function () {
      reveal.removeEventListener('transitionend', done);
      reveal.style.height = '';
      reveal.style.transition = '';
      reveal.classList.remove('pfaq__reveal--animating');
      if (!open) details.open = false;
    };
    reveal.addEventListener('transitionend', done);
  }

  on('click', '.pfaq__summary, .npd-summary', function (e, summary) {
    var details = summary.closest('details');
    if (!details) return;
    e.preventDefault();
    animateDetails(details, !details.open);
  });

  /* landing-page buy-box FAQ: plain button + panel, one open at a time is not
     enforced — the reference lets several stay open */

  on('click', '[data-npd-bbfaq]', function (e, btn) {
    e.preventDefault();
    var panel = btn.nextElementSibling;
    if (!panel) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    panel.hidden = open;
    var sign = btn.querySelector('.igacne__bb-faq-sign');
    if (sign) sign.textContent = open ? '+' : '\u2212';
  });

  /* carousel dots */

  on('click', '[data-npd-dot]', function (e, dot) {
    e.preventDefault();
    var wrap = dot.closest('[data-npd-carousel], slider-component');
    if (!wrap) return;
    var track = wrap.querySelector('[data-npd-track], .press-mention__carousel, .multicolumn-list');
    if (!track) return;
    var kids = $$(':scope > *', track);
    var i = parseInt(dot.getAttribute('data-npd-dot'), 10);
    if (kids[i]) track.scrollTo({ left: kids[i].offsetLeft - kids[0].offsetLeft, behavior: 'smooth' });
    $$('[data-npd-dot]', wrap).forEach(function (d) { d.classList.toggle('is-active', d === dot); });
  });

  /* --------------------------------------------------- review grid filtering */

  on('click', '[data-npd-rvg-filter]', function (e, btn) {
    e.preventDefault();
    var wrap = btn.closest('.rvg');
    if (!wrap) return;
    var panel = wrap.querySelector('[data-npd-rvg-panel]');
    if (!panel) return;
    panel.hidden = !panel.hidden;
    btn.setAttribute('aria-expanded', !panel.hidden);
  });

  on('click', '[data-npd-rvg-star]', function (e, btn) {
    e.preventDefault();
    var wrap = btn.closest('.rvg');
    if (!wrap) return;
    var want = btn.getAttribute('data-npd-rvg-star');

    $$('[data-npd-rvg-star]', wrap).forEach(function (b) {
      b.classList.toggle('is-active', b === btn);
    });

    var shown = 0;
    $$('[data-npd-rvg-rating]', wrap).forEach(function (card) {
      var keep = want === 'all' || card.getAttribute('data-npd-rvg-rating') === want;
      card.hidden = !keep;
      if (keep) shown++;
    });

    var empty = wrap.querySelector('[data-npd-rvg-empty]');
    if (empty) empty.hidden = shown > 0;
  });

  /* ------------------------------------------- clinician review "show more" */

  on('click', '[data-npd-clamp-toggle]', function (e, btn) {
    e.preventDefault();
    var text = btn.parentElement.querySelector('[data-npd-clamp]');
    if (!text) return;
    var open = text.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open);
    btn.textContent = open ? (btn.getAttribute('data-less') || 'Show less')
                           : (btn.getAttribute('data-more') || 'Show more');
  });

  /* ----------------------------------------------------------- review tabs */

  on('click', '[data-npd-tab]', function (e, btn) {
    e.preventDefault();
    var wrap = btn.closest('[data-npd-tabs]');
    if (!wrap) return;
    var key = btn.getAttribute('data-npd-tab');

    $$('[data-npd-tab]', wrap).forEach(function (b) {
      var active = b === btn;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-selected', active);
    });

    /* whole panels, where a section uses them */
    $$('[data-npd-panel]', wrap).forEach(function (p) {
      var active = p.getAttribute('data-npd-panel') === key;
      p.classList.toggle('is-active', active);
      p.hidden = !active;
    });

    /* individual slides in one shared track */
    $$('[data-npd-slide]', wrap).forEach(function (slide) {
      slide.hidden = slide.getAttribute('data-npd-slide') !== key;
    });

    var viewport = $('.norse-reviews-tabs__viewport', wrap);
    if (viewport) viewport.scrollTo({ left: 0, behavior: 'smooth' });
  });

  /* ------------------------------------------------------------ add to cart */

  /* Both forms carry data-npd-form="checkout" or "cart".
     "checkout" adds the item, then sends the customer straight to /checkout —
     the item still goes through the cart, so selling plans and cart discounts hold.
     With JavaScript off, the form's return_to=/checkout does the same thing. */

  /* Capture phase, so this runs before any handler the theme has bound directly to
     the form. Once we know the form is ours we stop propagation outright, which
     keeps a theme's own product-form script from also posting the same item. */
  function rootPath() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '');
  }

  function go(where) { window.location.assign(rootPath() + '/' + where); }

  function npdAdd(form, host) {
    var mode = (host.getAttribute('data-npd-form') || 'checkout').trim();
    var btn  = form.querySelector('[type="submit"]');
    var fd   = new FormData(form);
    var item = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) };
    if (!item.id) return false;
    var plan = fd.get('selling_plan');
    if (plan) item.selling_plan = parseInt(plan, 10);

    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

    fetch(rootPath() + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (r) { return r.json().then(function (b) { if (!r.ok) throw b; return b; }); })
      .then(function () {
        /* Confirm the cart really has something before sending anyone to checkout.
           Hitting /checkout on an empty cart bounces the shopper back to the top of
           the page they came from, which reads exactly like the button did nothing. */
        return fetch(rootPath() + '/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (!cart || !cart.item_count) {
              throw { description: 'The item did not reach the cart. Check the product and variant are available.' };
            }
            /* Shopify blocks navigation to /checkout inside the theme editor, so a
               "go straight to checkout" button there adds the item and then appears
               to do nothing. Open the cart instead and say why, rather than looking
               broken to whoever is editing. */
            var inEditor = !!(window.Shopify && window.Shopify.designMode);
            if (mode === 'checkout' && !inEditor) { go('checkout'); return; }
            if (mode === 'checkout' && inEditor) {
              var note = form.parentElement && form.parentElement.querySelector('.product-form__error-message');
              if (note) {
                note.textContent = 'Added. The theme editor blocks checkout — open the preview URL to test the full flow.';
                var nw = note.closest('.product-form__error-message-wrapper');
                if (nw) nw.hidden = false;
              }
            }
            if (window.clearedCart && typeof window.clearedCart.refresh === 'function') {
              return window.clearedCart.refresh().then(window.clearedCart.open);
            }
            var opener = document.querySelector('[data-cart-open]');
            if (opener) { opener.click(); return; }
            if (!inEditor) go('cart');
          });
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Could not add to cart';
        var box = form.parentElement && form.parentElement.querySelector('.product-form__error-message');
        if (box) {
          box.textContent = msg;
          var w = box.closest('.product-form__error-message-wrapper');
          if (w) w.hidden = false;
        } else { alert(msg); }
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = label; }
      });
    return true;
  }

  /* Intercept at click, in the capture phase, and stop the event dead. No submit
     event is ever generated, so no theme or app script that listens for submit can
     take the click off us — which is what was adding the item and then stalling. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[type="submit"], input[type="submit"]');
    if (!btn) return;
    var form = btn.form || btn.closest('form');
    if (!form) return;
    var host = form.closest('[data-npd-form]');
    if (!host) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    npdAdd(form, host);
  }, true);

  document.addEventListener('submit', function (e) {
    /* The mode lives on a wrapper we render ourselves. Relying on Shopify's
       {% form %} tag to carry a hyphenated data- attribute was not something we
       could verify, and if it is dropped the selector never matches at all. */
    var form = e.target.closest('form');
    if (!form) return;
    var host = form.closest('[data-npd-form]');
    if (!host) return;

    e.stopPropagation();
    var mode = host.getAttribute('data-npd-form') || 'checkout';
    var btn  = form.querySelector('[type="submit"]');
    var fd   = new FormData(form);
    var item = { id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) };
    if (!item.id) return;                       /* let the browser post it normally */
    var plan = fd.get('selling_plan');
    if (plan) item.selling_plan = parseInt(plan, 10);

    e.preventDefault();
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (r) { return r.json().then(function (b) { if (!r.ok) throw b; return b; }); })
      .then(function () {
        if (mode === 'checkout') { go('checkout'); return; }
        /* hand off to the theme's own cart if it has one, else go to the cart page */
        if (window.clearedCart && typeof window.clearedCart.refresh === 'function') {
          return window.clearedCart.refresh().then(window.clearedCart.open);
        }
        /* open whatever cart the theme actually has: its own opener, then a
           drawer element, then the cart page. The old code fired a custom event
           no theme listens for, so the click appeared to do nothing. */
        var opener = document.querySelector('[data-cart-open]');
        if (opener) { opener.click(); return; }
        if (window.CartDrawer && typeof window.CartDrawer.open === 'function') {
          window.CartDrawer.open(); return;
        }
        go('cart');
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Could not add to cart';
        var box = form.parentElement && form.parentElement.querySelector('.product-form__error-message');
        if (box) {
          box.textContent = msg;
          box.closest('.product-form__error-message-wrapper').hidden = false;
        } else {
          alert(msg);
        }
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.innerHTML = label; }
      });
  }, true);

  /* ---------------------------------------------------------- sticky add-to-cart */

  function initSticky() {
    var bar = $('sticky-add-to-cart, [data-npd-sticky]');
    if (!bar) return;
    var anchor = $('[data-npd-atc-anchor]');
    if (!anchor) return;

    var ticking = false;
    var update = function () {
      ticking = false;
      var r = anchor.getBoundingClientRect();
      /* show it once the real button has scrolled off the top, hide it again
         when the button is back on screen or the page is near the footer */
      bar.classList.toggle('sticky-atc--visible', r.bottom < 0);
    };
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ------------------------------------------------------------ deferred media */

  on('click', '.deferred-media__poster-button, .custom-gallery__thumb-play, [data-npd-play]', function (e, btn) {
    e.preventDefault();
    var host = btn.closest('.deferred-media, .custom-gallery__video-wrapper, [data-npd-media]');
    if (!host) return;
    var tpl = host.querySelector('template');
    if (tpl) {
      host.appendChild(tpl.content.cloneNode(true));
      tpl.remove();
    }
    host.setAttribute('loaded', 'true');
    var media = host.querySelector('video, iframe');
    if (media && media.tagName === 'VIDEO' && typeof media.play === 'function') media.play();
  });

  /* -------------------------------------------------------------- carousels */

  on('click', '[data-npd-scroll]', function (e, btn) {
    e.preventDefault();
    /* Find the scroller by walking out from the button until an ancestor
       contains something that actually scrolls sideways. Matching on a bare
       ancestor selector picked the button's own wrapper, which holds no track
       at all — that is why these arrows used to do nothing. */
    function scrollerIn(root) {
      var marked = root.querySelector('[data-npd-track]');
      if (marked && marked.scrollWidth - marked.clientWidth > 4) return marked;
      var cands = root.querySelectorAll('*');
      for (var i = 0; i < cands.length; i++) {
        var el = cands[i];
        if (el.scrollWidth - el.clientWidth <= 4) continue;
        var ox = getComputedStyle(el).overflowX;
        if (ox === 'auto' || ox === 'scroll') return el;
      }
      return null;
    }

    var track = null;
    var node = btn.closest('[data-npd-carousel]') || btn.closest('[data-npd-tabs]');
    if (node) track = scrollerIn(node);
    if (!track) {
      node = btn.parentElement;
      while (node && node !== document.body && !track) {
        track = scrollerIn(node);
        node = node.parentElement;
      }
    }
    if (!track) return;

    /* Step by one card. Where the scroller wraps a single list, the cards are
       that list's children, not the scroller's — stepping by the list itself
       would jump straight to the end. */
    var host = track;
    while (host.children.length === 1 && host.firstElementChild.children.length > 1) {
      host = host.firstElementChild;
    }
    var kid = null, kids = host.children;
    for (var j = 0; j < kids.length; j++) {
      if (kids[j].offsetWidth > 4 && getComputedStyle(kids[j]).display !== 'none') { kid = kids[j]; break; }
    }
    var step = (kid ? kid.offsetWidth : 260) + 16;
    var dir = btn.getAttribute('data-npd-scroll') === 'prev' ? -step : step;
    var max = track.scrollWidth - track.clientWidth;
    var to = Math.max(0, Math.min(max, track.scrollLeft + dir));
    try { track.scrollTo({ left: to, behavior: 'smooth' }); }
    catch (err) { track.scrollLeft = to; }
  });

  /* ------------------------------------------------- under-filled carousels */

  /* A row built for four cards that only holds two would otherwise hug the left.
     Centre the track whenever its content fits, leave it alone when it scrolls. */

  var TRACKS = '.multicolumn-list, .norse-ambassador-section__list, .press-mention__carousel,'
             + ' .norse-reviews-tabs__track, .ag-review-bar__track, .ni-blocks-track';

  function balanceTracks() {
    $$(TRACKS).forEach(function (track) {
      if (track.classList.contains('ag-review-bar__track')) return;   /* marquee */

      /* The scroll container is sometimes the track, sometimes its parent. */
      var scroller = track;
      if (getComputedStyle(track).overflowX === 'visible' && track.parentElement) {
        scroller = track.parentElement;
      }
      /* scrollWidth counts the peek padding these tracks carry, and a grid whose
         columns are sized to fill leaves no gap at all — neither reflects how wide
         the cards actually are. Measure the cards themselves. */
      var kids = $$(':scope > *', track).filter(function (k) {
        return getComputedStyle(k).display !== 'none' && k.offsetWidth > 4;
      });
      if (!kids.length) return;
      var first = kids[0], last = kids[kids.length - 1];
      var content = (last.offsetLeft + last.offsetWidth) - first.offsetLeft;
      var gutter = window.innerWidth >= 750 ? 30 : 40;      /* both gutters */

      /* Centre as soon as the cards fit at all — a row that clears the width by
         only a few pixels still looks wrong pinned to the left. The gutter is
         only required before we also override the track's own padding. */
      var fits   = content <= scroller.clientWidth + 2;
      var roomy  = content <= scroller.clientWidth - gutter + 2;

      track.classList.toggle('npd-centered', fits);
      scroller.classList.toggle('npd-fits', roomy);

      /* Centring an overflowing flex row pushes content off both edges, so the
         first card ends up behind the viewport. Check after the class lands. */
      track.classList.remove('npd-overflowing');
      if (fits && scroller.scrollWidth > scroller.clientWidth + 2) {
        track.classList.add('npd-overflowing');
      }
      if (fits && scroller.scrollLeft) scroller.scrollLeft = 0;

      /* Grid tracks size their columns to fill the container, so centring the
         track moves nothing. Size the columns to the cards instead. */
      if (getComputedStyle(track).display.indexOf('grid') === 0) {
        track.style.gridAutoColumns = fits ? 'max-content' : '';
        track.style.gridTemplateColumns = fits ? 'repeat(' + kids.length + ', max-content)' : '';
      }

      /* Arrows are pointless when nothing scrolls. */
      var wrap = track.closest('[data-npd-carousel], slider-component, .norse-reviews-tabs, .ni-section');
      if (wrap) {
        $$('[data-npd-scroll], .slider-button, .multicolumn__button, .norse-reviews-tabs__arrow', wrap)
          .forEach(function (b) { b.hidden = fits; });
      }
    });
  }

  /* ---------------------------------------------------------- countdown */

  /* A per-visitor countdown, stored so it does not restart on every page view.
     It is a nudge, not a real deadline — when it reaches zero it simply stops. */

  function initCountdowns() {
    $$('[data-npd-countdown]').forEach(function (el) {
      if (el._npdTimer) return;
      var minutes = parseInt(el.getAttribute('data-npd-countdown'), 10);
      if (!minutes) return;

      var storeKey = 'npd-countdown-' + minutes;
      var ends;
      try { ends = parseInt(window.sessionStorage.getItem(storeKey), 10); } catch (e) {}
      if (!ends || isNaN(ends) || ends < Date.now()) {
        ends = Date.now() + minutes * 60000;
        try { window.sessionStorage.setItem(storeKey, String(ends)); } catch (e) {}
      }

      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      var tick = function () {
        var left = Math.max(0, ends - Date.now());
        var s = Math.floor(left / 1000);
        el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s / 60) % 60) + ':' + pad(s % 60);
        if (left <= 0) { clearInterval(el._npdTimer); el._npdTimer = null; }
      };
      tick();
      el._npdTimer = setInterval(tick, 1000);
    });
  }

  /* ------------------------------------------------------ in-page anchors */

  /* Every call-to-action on these pages points at an anchor rather than a new
     URL. Scroll to it, offset by whatever sticky header the theme has, and
     update the address bar so back still works. */

  function stickyOffset() {
    var most = 0;
    document.querySelectorAll('header, .header-wrapper, .section-header, sticky-header').forEach(function (el) {
      var c = getComputedStyle(el);
      if (c.position !== 'fixed' && c.position !== 'sticky') return;
      var r = el.getBoundingClientRect();
      if (r.top <= 1 && r.height > most && r.height < 200) most = r.height;
    });
    return most + 12;
  }

  function scrollToTarget(target) {
    /* Work out the destination once. Recomputing it while the page is moving
       lets lazy content drift the number and the scroll overshoots. */
    var top = Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - stickyOffset());
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduce) { window.scrollTo(0, top); return; }

    try { window.scrollTo({ top: top, behavior: 'smooth' }); }
    catch (e) { window.scrollTo(0, top); return; }

    /* Two things can go wrong after this point: some embedded browsers ignore
       smooth scrolling without erroring, and content above the target can settle
       mid-animation and move it. So once the animation has had its time,
       re-measure the target and land on it exactly. */
    clearTimeout(window.__npdScrollFix);
    clearTimeout(window.__npdScrollSettle);
    window.__npdScrollFix = setTimeout(function () {
      if (Math.abs(Math.round(window.pageYOffset) - Math.round(top)) > 4) window.scrollTo(0, top);
      window.__npdScrollSettle = setTimeout(function () {
        var fresh = Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - stickyOffset());
        if (Math.abs(Math.round(window.pageYOffset) - Math.round(fresh)) > 6) window.scrollTo(0, fresh);
      }, 260);
    }, 700);
  }

  on('click', 'a[href^="#"]', function (e, a) {
    var raw = a.getAttribute('href');
    if (!raw || raw === '#' || raw.length < 2) { e.preventDefault(); return; }
    var target = document.getElementById(raw.slice(1)) || document.querySelector(raw);
    if (!target) return;                      /* let the browser try it */
    e.preventDefault();
    scrollToTarget(target);
    if (history.replaceState) history.replaceState(null, '', raw);
    target.setAttribute('tabindex', '-1');
  });

  /* ---------------------------------------------------------------- boot */

  function init() {
    $$('.custom-gallery').forEach(function (g) { syncThumbs(g); attachGalleryDrag(g); });
    $$('[data-npd-buybox]').forEach(renderBox);
    initSticky();
    balanceTracks();
    initCountdowns();
    window.addEventListener('resize', balanceTracks, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* theme editor: re-init when a section is redrawn */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();
